// 该store是所有弹框的store

const downSuccessCode = 10000 // 下载成功

export default {
  namespaced: true,
  state: () => ({
    updateVipLevelDialogVisible: false, // 升级会员弹框
    settingDialogVisible: false, // 设置的弹框

    downSuccessCode, // 下载成功的状态码
    downErrorCode: downSuccessCode, // 下载失败错误的错误码，默认是成功
  }),
  mutations: {
    vuexChangeUpdateVipLevelDialog (state, flag = true) {
      state.updateVipLevelDialogVisible = flag
    },

    vuexChangeSettingDialogVisible (state, flag) {
      state.settingDialogVisible = flag
    },

    changeDownErrorCode (state, code = downSuccessCode) {
      state.downErrorCode = code
    }

  }
}
